export default __webpack_public_path__ + "static/media/time_management_active.176a49e8.svg";